import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  ArcElement,
  Chart as ChartJS,
  Legend as ChartjsLegend,
  Tooltip,
  TooltipItem,
  TooltipModel,
} from "chart.js";

ChartJS.register(ArcElement, ChartjsLegend);

export default function DonutChart(props) {
  const [load, setLoad] = useState(false);
  const [plugins, setPlugins] = useState([]);
  useEffect(() => {
    setLoad(false);
    setLoad(true);
    setPlugins([
      {
        beforeDraw: function (chart) {
          var width = chart.width,
            height = chart.height,
            ctx = chart.ctx;
          ctx.restore();
          var fontSize = (height / 70).toFixed(2);
          ctx.font = fontSize + "em sans-serif";
          ctx.textBaseline = "middle";
          var text = props.text,
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 1.85;
          ctx.fillStyle = props.textColor;

          ctx.fillText(text, textX, textY);
          ctx.save();
        },
        afterUpdate: function (chart) {
          const arcs = chart.getDatasetMeta(0).data;

          arcs.forEach(function (arc) {
            arc.round = {
              x: (chart.chartArea.left + chart.chartArea.right) / 2,
              y: (chart.chartArea.top + chart.chartArea.bottom) / 2,
              radius: (arc.outerRadius + arc.innerRadius) / 2,
              thickness: (arc.outerRadius - arc.innerRadius) / 2,
              backgroundColor: arc.options.backgroundColor,
            };
          });
        },
        afterDraw: (chart) => {
          const { ctx, canvas } = chart;

          chart.getDatasetMeta(0).data.forEach((arc) => {
            const startAngle = Math.PI / 2 - arc.startAngle;
            const endAngle = Math.PI / 2 - arc.endAngle;

            ctx.save();
            ctx.translate(arc.round.x, arc.round.y);
            ctx.fillStyle = arc.options.backgroundColor;
            ctx.beginPath();
            ctx.arc(
              arc.round.radius * Math.sin(endAngle),
              arc.round.radius * Math.cos(endAngle),
              arc.round.thickness,
              0,
              2 * Math.PI
            );
            ctx.closePath();
            ctx.fill();
            ctx.restore();
          });
        },
      },
    ]);
  }, [props]);

  const data = {
    labels: [],
    datasets: [
      {
        data: [...props.data],
        backgroundColor: [...props.colors],
        hoverBackgroundColor: [...props.colors],
        borderWidth: 1,
      },
    ],
    text: "25%",
  };

  const options = {
    responsive: true,
    cutout: 65,
    maintainAspectRatio: false,
    legend: {
      display: false,
      position: "top",
      usePointStyle: "true",
      labels: {
        fontSize: 12,
        padding: 25,
        fontColor: "#6D7278",
        fontFamily: "kanit light",
      },
    },
    arc: {
      borderJoinStyle: "round",
    },
  };
  return (
    <>
      {load && (
        <Doughnut
          data={data}
          options={options}
          height={180}
          plugins={plugins}
        />
      )}
    </>
  );
}
